var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcRoundOndemandVideo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.9998 9H8.99976C5.69976 9 2.99976 11.7 2.99976 15V51C2.99976 54.3 5.69976 57 8.99976 57H23.9998V60C23.9998 61.65 25.3498 63 26.9998 63H44.9998C46.6498 63 47.9998 61.65 47.9998 60V57H62.9998C66.2998 57 68.9697 54.3 68.9697 51L68.9997 15C68.9997 13.4087 68.3676 11.8826 67.2424 10.7574C66.1172 9.63214 64.591 9 62.9998 9ZM59.9998 51H11.9998C10.3498 51 8.99976 49.65 8.99976 48V18C8.99976 16.35 10.3498 15 11.9998 15H59.9998C61.6497 15 62.9998 16.35 62.9998 18V48C62.9998 49.65 61.6497 51 59.9998 51ZM43.4398 35.61L31.4998 42.45C29.4898 43.59 26.9998 42.12 26.9998 39.84V26.16C26.9998 23.85 29.4898 22.41 31.4998 23.55L43.4398 30.39C45.4498 31.56 45.4498 34.44 43.4398 35.61Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcRoundOndemandVideo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_round-ondemand-video.a5d498670ba8da2a02f347f92555eef0.svg";